import { Flex, Inline } from "PFComponents/containers";
import { Tile } from "PFComponents/tile";
import { ReactNode } from "react";

import css from "./header_toolbox.module.scss";

type HeaderToolboxProps = {
  items?: ReactNode[];
  className?: string;
};

export const HeaderToolbox = ({ items = [], className }: HeaderToolboxProps) => {
  if (!items.length) {
    return null;
  }

  return (
    <Tile paddingVariant="md" className={className} variant="light">
      <Inline alignItems="center" gap={null}>
        {items.map((element, index) => (
          <Flex key={index} center className={css.item}>
            {element}
          </Flex>
        ))}
      </Inline>
    </Tile>
  );
};
